import { Box, CircularProgress, Grid, Paper } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ConversationLogList } from '../components/ConversationLogList'
import { CustomExplain } from '../components/CustomExplain'
import { CustomTitle } from '../components/CustomTitile'
import { Footer } from '../components/Footer'
import { ModalConfirmDialog } from '../components/ModalConfirmDialog'
import { loadStatus } from '../constants/loadStatus'
import { useAuth } from '../hooks/useAuth'
import { useC801ConversationRecordListGet } from '../hooks/useC801ConversationRecordListGet'
import { useC807ConversationDownload } from '../hooks/useC807ConversationDownload'
import { useC809ConversationDelete } from '../hooks/useC809ConversationDelete'
import { useCloudStorage } from '../hooks/useCloudStorage'
import { useConversation } from '../hooks/useConversation'
import type { ConversationLogIf } from '../interfaces/ConversationLogIf'
import { LanguageContext } from '../util/LanguageContext'
import { SideMenu } from './SideMenu'

// 会話記録画面
export const ConversationLog = () => {
  const navigate = useNavigate()
  // hooks
  const auth = useAuth()
  const conv = useConversation()
  const c801 = useC801ConversationRecordListGet()
  const c807 = useC807ConversationDownload()
  const c809 = useC809ConversationDelete()
  const cs = useCloudStorage()

  // 文字列変換用
  const translation = useContext(LanguageContext)

  // ローディングステータス監視
  useEffect(() => {
    if (
      c801.loading === loadStatus.LOADING ||
      c807.loading === loadStatus.LOADING ||
      c809.loading === loadStatus.LOADING
    ) {
      auth.setIsDisable(true)
    } else {
      auth.setIsDisable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [c801.loading, c807.loading, c809.loading])
  // ダイアログ
  const [openDialog, setOpenDialog] = useState(false)
  const [errorDialog, setErrorDialog] = useState('')

  // 会話記録配列
  const [convLogs, setConvLogs] = useState<ConversationLogIf[]>([])

  // 会話編集ハンドラ
  const ConversationEditHandler = async (convId: string, orgText: boolean) => {
    conv.setConvId(convId)
    conv.setOrgText(orgText)
    navigate('/conversations')
  }

  useEffect(() => {
    const fetchData = async () => {
      const result = await c801.execConversationRecordListGet(auth.deviceId)
      if (result.success) {
        if (result.info) {
          setConvLogs(result.info!)
        }
      } else {
        setErrorDialog(result.message!)
        setOpenDialog(true)
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const ConversationDownloadHandler = async (convId: string) => {
    // C807 会話記録ダウンロード
    const result = await c807.execConversationDownload(convId)
    if (result.success) {
      const resultCs = await cs.execDownloadFile(result.info!.storage_path, result.info!.file_name)
      if (resultCs.success) {
      } else {
        setErrorDialog(resultCs.message!)
        setOpenDialog(true)
      }
    } else {
      setErrorDialog(result.message!)
      setOpenDialog(true)
    }
  }

  const ConversationDeleteHandler = async (convId: string) => {
    //C809　会話記録削除
    const result = await c809.execConversationDelete(convId)
    if (result.success) {
      const result = await c801.execConversationRecordListGet(auth.deviceId)
      if (result.success) {
        if (result.info) {
          setConvLogs(result.info!)
        } else {
          setConvLogs([])
        }
      } else {
        setErrorDialog(result.message!)
        setOpenDialog(true)
      }
    } else {
      setErrorDialog(result.message!)
      setOpenDialog(true)
    }
  }

  // ダイアログクローズ
  const handleDialogClose = () => {
    setErrorDialog('')
    setOpenDialog(false)
  }

  return (
    <>
      {openDialog && (
        <ModalConfirmDialog
          open={openDialog}
          text={errorDialog}
          onClick={() => handleDialogClose()}
        />
      )}
      <Box sx={{ display: 'flex', p: 0 }}>
        <Box sx={{ p: 0, width: '338px', flexShrink: 0 }}>
          <SideMenu />
        </Box>
        <Box sx={{ flexGrow: 1 }} display="flex" flexDirection="column">
          <Box marginTop={13}>
            <Box>
              <CustomTitle>{translation['label_conversation_history']}</CustomTitle>
            </Box>
            <Box>
              <CustomExplain>{translation['message_conversation_history_info']}</CustomExplain>
            </Box>
            <Box
              sx={{
                marginTop: '40px',
              }}
            >
              <Paper
                sx={{
                  p: '32px',
                  margin: '0px 64px 0px 0px',
                  width: '1650px',
                  height: 'calc(100vh - 394px)',
                }}
              >
                <Grid
                  container
                  spacing={2}
                  p={2}
                  style={{
                    font: 'normal normal normal 21px/32px Noto Sans JP',
                    minWidth: '1600px',
                  }}
                >
                  <ConversationLogList
                    items={convLogs}
                    onEdit={(convId, orgText) => ConversationEditHandler(convId, orgText)}
                    onDownload={convId => ConversationDownloadHandler(convId)}
                    onDelete={convId => ConversationDeleteHandler(convId)}
                  />
                </Grid>
              </Paper>
            </Box>
            <Box
              sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 9999,
              }}
            >
              {(c801.loading === loadStatus.LOADING ||
                c807.loading === loadStatus.LOADING ||
                c809.loading === loadStatus.LOADING) && <CircularProgress />}
            </Box>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  )
}
